export enum TipoProrrogacao {
  Padrao = 'Padrao',
  Licenca = 'Licenca',
  Recuperacao = 'Recuperacao'
}
